import {platform} from "@/api/platform";

import equipment from "./quiz/equipment";
import profile from "./quiz/profile";
import {retryRequest} from "@/helpers/request";

export default {
    namespaced: true,
    state: {
        countries: []
    },
    getters: {
        countries: state => state.countries,
    },
    actions: {
        fetch(context) {

            if (context.state.countries && 0 < context.state.countries.length) {

                return context.state.countries
            }

            return retryRequest(() => platform.get("/api/v2/partner/countrieslist"))
                .then(response => context.state.countries = response.data.results);
        }
    },
    modules: {
        equipment,
        profile,
    }
}